<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-row>
          <b-col>
            <c-input
              inputType="text"
              inputId="OrganizationName"
              labelText="Organization Name"
              v-model="organization.name"
              class="mt-3"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-form-file
              @change="readLogo"
              :state="Boolean(organization.logo)"
              placeholder="Choose a file..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <eb-select
              v-if="!loading"
              type="text"
              v-model="organization.orgAccessLevel"
              :options="orgAccessOptions"
              @input="changeLevel"
              label="label"
              placeholder="Select org Access Level"
              :selected="organization.orgAccessLevel"
              class="border-style"
            ></eb-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="checkOrgoLevel">
            <multiselect
              v-model="organization.orgAccessList"
              tag-placeholder="Add this as new org Access"
              placeholder="Select org Access List"
              label="userName"
              track-by="userName"
              :options="orgAccessListOptions"
              :multiple="true"
              :taggable="false"
              :open-direction="'top'"
            ></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <GmapAutocomplete
              @place_changed="(e) => this.setPlace(e)"
              class="mt-1 location-search"
              :options="{
                fields: ['geometry', 'formatted_address', 'address_components'],
              }"
            ></GmapAutocomplete>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <c-input
              inputType="text"
              inputId="registrationNo"
              labelText="Registration No "
              v-model="organization.registrationNo"
              class="mt-3"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <c-input
              inputType="text"
              inputId="gstNo"
              labelText="GST No"
              v-model="organization.gstNo"
              class="mt-3"
            />
          </b-col>
        </b-row>
        <b-row class="mx-1">
          <b-form-checkbox switch v-model="organization.isOwnCompany"
            ><span class="mx-2">Own Company</span></b-form-checkbox
          >
        </b-row>
        <slot name="footer-button" :data="organization"></slot>
      </b-col>
      <b-col md="6">
        <b-row>
          <b-col>
            <c-input
              inputType="text"
              inputId="fssciNo"
              labelText="FSSAI  No"
              v-model="organization.fssciNo"
              class="mt-3"
            />
          </b-col>
        </b-row>
        <div>
          <GmapMap
            :center="position"
            :zoom="7"
            map-type-id="terrain"
            class="map-align"
          >
            <GmapMarker label="★" :draggable="true" :position="position" />
          </GmapMap>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import locationMixins from "@/mixins/addressLocation";
import Vue from "vue";
import { mapGetters } from "vuex";
export default {
  name: "organizationModel",
  props: ["orgoListData"],
  mixins: [locationMixins],
  data() {
    return {
      loading: false,
      organization: {
        name: "",
        logo: "",
        registrationNo: "",
        gstNo: "",
        fssciNo: "",
        orgAccessLevel: "",
        orgAccessList: [],
        isOwnCompany: false,
        location: {
          coordinates: [],
        },
      },
      position: {
        lat: 0,
        lng: 0,
      },
      address: {
        country: "",
        state: "",
        city: "",
        zip: "",
      },
    };
  },
  components: {
    cInput,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
    checkOrgoLevel() {
      if (
        this.organization.orgAccessLevel &&
        this.organization.orgAccessLevel.value === "Limited"
      ) {
        return true;
      } else if (
        this.organization.orgAccessLevel &&
        this.organization.orgAccessLevel.value === "Global"
      ) {
        return false;
      }
    },
    orgAccessOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
        {
          label: "Limited",
          value: "Limited",
        },
      ];
    },

    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (obj.category === "OFFICE") {
            let arrayObj = {
              _id: obj?._id,
              userName: obj?.authentication?.userName,
              email: obj?.authentication?.email,
              phone: obj?.authentication?.phone,
              password: "",
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
  },
  methods: {
    async setPlace(data) {
      let place = await data;
      let position = {
        lat: place?.geometry?.location?.lat(),
        lng: place?.geometry?.location?.lng(),
      };
      this.position = position;
      this.organization.location.coordinates[0] =
        place?.geometry?.location?.lng();
      this.organization.location.coordinates[1] =
        place?.geometry?.location?.lat();
      this.placechange(data);
      let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
      if (mapdata) {
        this.address.country = mapdata?.data?.Country;
        this.address.city = mapdata?.data?.City;
        this.address.state = mapdata?.data?.State;
        this.address.area = mapdata?.data?.Area ? mapdata?.data?.Area : "";
        this.address.zip = mapdata?.data?.zip ? mapdata?.data?.zip : "";
      }
    },
    readLogo(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.uploadImage(reader.result);
      };
      reader.onerror = (err) => {
        console.error("reader : ", err);
      };
    },
    // upload images to the S3 bucket
    async uploadImage(image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          if (res) {
            this.clearCustomToast();
            this.organization.logo = res.data.fileUrl;
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    changeLevel(event) {
      if (event.value === "Global") {
        this.organization.orgAccessList = null;
      }
    },
  },
  mounted() {
    this.loading = true;
    if (!this.$store.getters["partner/GetPartnerList"]?.length)
      this.$store.dispatch("partner/fetchPartnersList");
    this.organization.name = this.partnerAllData?.organization?.name;
    this.organization.registrationNo =
      this.partnerAllData?.organization?.registrationNo;
    this.organization.gstNo = this.partnerAllData?.organization?.gstNo;
    this.organization.fssciNo = this.partnerAllData?.organization?.fssciNo;
    this.organization.isOwnCompany =
      this.partnerAllData?.organization?.isOwnCompany;
    if (
      this.partnerAllData?.authorization?.orgAccess &&
      this.partnerAllData?.authorization?.orgAccess?.orgAccessLevel
    ) {
      this.organization.orgAccessLevel = {
        label: this.partnerAllData?.authorization?.orgAccess?.orgAccessLevel,
        value: this.partnerAllData?.authorization?.orgAccess?.orgAccessLevel,
      };
    }
    let filterOrgoList = [];
    if (Array.isArray(this.orgoListData) && this.orgoListData.length > 0) {
      this.orgoListData.forEach((obj) => {
        filterOrgoList.push(obj[0]);
      });
    }
    this.position.lng = Number(
      this.partnerAllData?.organization?.location?.coordinates[0]
    );
    this.position.lat = Number(
      this.partnerAllData?.organization?.location?.coordinates[1]
    );
    this.organization.orgAccessList = filterOrgoList;
    if (
      this.partnerAllData?.authorization?.orgAccess?.orgAccessLevel === "Global"
    ) {
      this.organization.orgAccessList = [];
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: "Lato";
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: var(--primary);
  color: white;
}
.custom-file-label {
  border-radius: 0px !important;
  border: 1px solid #dee2e6 !important;
  color: #dee2e6 !important;
}
.border-style-input {
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #d2d2d2;
  height: 40px;
  border-radius: 4px;
}
.pac-container {
  z-index: 100000 !important;
}
.map-align {
  width: 350px;
  height: 330px;
}
@media (max-width: 991px) {
  .map-align {
    width: 215px;
    height: 300px;
  }
}
@media (max-width: 767px) {
  .map-align {
    width: 350px;
    height: 330px;
    margin-bottom: 30px;
  }
}
</style>
